export type GuideFeatureDef = {
  key: string;
  title: string;
  text: string;
  tint: "lock" | "send" | "archive" | "hash" | "credit" | "num" | "legal" | "portal" | "sign" | "recurring" | "mail" | "docs" | "team" | "pay" | "backup";
};

export const GUIDE_FEATURES: GuideFeatureDef[] = [
  {
    key: "draft",
    tint: "lock",
    title: "Brouillon souple, validé figé",
    text: "Tant que c’est un brouillon, vous corrigez. Une fois envoyé, la pièce ne se modifie plus. Une erreur se corrige par un avoir.",
  },
  {
    key: "send",
    tint: "send",
    title: "Envoyer = valider + e-mail",
    text: "Un clic numérote la pièce, enregistre le PDF d’origine, puis envoie le mail. Pas de facture envoyée sans ce fichier, ni si la fiche société (ou le client pro) est incomplète.",
  },
  {
    key: "pdf",
    tint: "archive",
    title: "Le PDF d’origine",
    text: "Il est rangé à part, verrouillé, et on ne le réécrit jamais. C’est le document que vous gardez.",
  },
  {
    key: "coffre",
    tint: "archive",
    title: "Visible dans le Coffre",
    text: "La zone Archivage légal montre ce même fichier : voir et télécharger seulement. Ce n’est pas un dossier de Mes fichiers.",
  },
  {
    key: "hash",
    tint: "hash",
    title: "Empreinte unique",
    text: "Chaque pièce envoyée a une empreinte. Elle sert à prouver que le fichier n’a pas changé. Elle n’apparaît pas sur la facture.",
  },
  {
    key: "credit",
    tint: "credit",
    title: "Correction = avoir",
    text: "On n’efface pas une pièce déjà envoyée. On fait un avoir, puis une nouvelle facture si besoin.",
  },
  {
    key: "numbers",
    tint: "num",
    title: "Numéros suivis",
    text: "Devis, factures, avoirs : chacun a sa série. Un numéro déjà utilisé n’est jamais redonné. Le compteur ne recule pas.",
  },
  {
    key: "mentions",
    tint: "legal",
    title: "Mentions écrites par le logiciel",
    text: "Franchise, pénalités, SIREN, nature des opérations : le logiciel les pose tout seul. Le texte libre en pied n’est qu’un complément. Envoyer bloque si l’identité manque. Multi-taux : le pied ventile la TVA.",
  },
  {
    key: "portal",
    tint: "portal",
    title: "Portail client",
    text: "Votre client ouvre un lien sécurisé et voit le vrai PDF, pas une page recréée. Chaque envoi a son propre accès.",
  },
  {
    key: "sign",
    tint: "sign",
    title: "Devis signé → brouillon de facture",
    text: "Le client signe (nom + mention). Ça ouvre une facture en brouillon. Jamais une facture déjà validée.",
  },
  {
    key: "recurring",
    tint: "recurring",
    title: "Factures récurrentes",
    text: "Selon votre réglage Autofacturer : brouillon à préparer, ou envoi automatique, ou brouillon puis envoi à l’échéance.",
  },
  {
    key: "reminders",
    tint: "mail",
    title: "Relances",
    text: "Selon les cases cochées et l’heure choisie. Une relance déjà partie ne repart pas une seconde fois.",
  },
  {
    key: "docs",
    tint: "docs",
    title: "Documents du client",
    text: "Ses devis et factures, plus les PDF envoyés depuis le Coffre. On retire une copie ou un brouillon. Une pièce validée, non.",
  },
  {
    key: "team",
    tint: "team",
    title: "Société et équipe",
    text: "Les collègues du même groupe, que vous cochez, voient la même société. Les fichiers restent ceux du propriétaire.",
  },
  {
    key: "pay",
    tint: "pay",
    title: "Paiement en ligne",
    text: "GoCardless : le client signe le mandat, vous prélevez une facture envoyée, « Payé » se pose tout seul à la confirmation. Stripe et PayPal sont connectés.",
  },
  {
    key: "backup",
    tint: "backup",
    title: "Copie de secours",
    text: "Dès l’envoi, le PDF est aussi copié sur un second disque. Si la copie s’arrête, vous êtes prévenu. Ce n’est pas un second original : l’original, c’est le fichier d’archive.",
  },
];
